import $ from 'jquery';

$.fn.serializeObject = function () {
    return $(this).serializeArray().reduce(function (prev, { name, value }) {
        const result = { ...prev };
        result[name] = value;
        return result;
    }, {});
};
